import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { isFunction } from '@elliemae/ds-utilities/utils';
import { DOCUMENT } from '@elliemae/ds-utilities/platform';
import './ie-remove-polyfill.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'portal';
var canRenderPortal = isFunction(ReactDOM.createPortal); // TODO: If this is rendered on server, is going to break

var DSPortal = /*#__PURE__*/function (_Component) {
  _inherits(DSPortal, _Component);

  var _super = _createSuper(DSPortal);

  function DSPortal() {
    var _this;

    _classCallCheck(this, DSPortal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isMounted: false
    });

    return _this;
  }

  _createClass(DSPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onRender = this.props.onRender;
      this.portalEl = this.createPortalContainer();

      if (DOCUMENT && this.portalEl) {
        DOCUMENT.body.appendChild(this.portalEl);
        onRender();
        this.setState({
          isMounted: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!canRenderPortal) {
        this.renderNoPortal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portalEl) {
        this.portalEl.parentNode.removeChild(this.portalEl);
      }
    }
  }, {
    key: "createPortalContainer",
    value: function createPortalContainer() {
      if (!DOCUMENT) return null;
      var className = this.props.className;

      var _convertPropToCssClas = convertPropToCssClassName(blockName, className),
          cssClassName = _convertPropToCssClas.cssClassName;

      var container = DOCUMENT.createElement('div');
      container.classList.add(cssClassName);
      container.setAttribute('data-testid', 'portal');
      return container;
    }
  }, {
    key: "renderNoPortal",
    value: function renderNoPortal() {
      var children = this.props.children;
      ReactDOM.unstable_renderSubtreeIntoContainer(this, /*#__PURE__*/React.createElement("div", null, children), this.portalEl);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isMounted = this.state.isMounted;
      return !canRenderPortal || !isMounted ? null : /*#__PURE__*/ReactDOM.createPortal(children, this.portalEl);
    }
  }]);

  return DSPortal;
}(Component);

_defineProperty(DSPortal, "defaultProps", {
  onRender: function onRender() {
    return null;
  }
});

export default DSPortal;
export { DSPortal };
//# sourceMappingURL=DSPortal.js.map
